import { lazy } from 'react';

// Après un déploiement, les morceaux (chunks) de l'ancienne version n'existent plus : un onglet resté ouvert qui
// en demande un reçoit la page d'accueil à la place, le chargement échoue et React démonte tout (page blanche).
// On recharge alors la page une fois pour prendre la nouvelle version ; si le morceau manque encore juste après
// ce rechargement, l'erreur remonte normalement au lieu de recharger en boucle.
const RELOAD_KEY = 'deepflow_chunk_reload_at';
const RELOAD_WINDOW_MS = 30000;

export const isChunkLoadError = (error) =>
  /ChunkLoadError|Loading (CSS )?chunk .* failed|dynamically imported module/i.test(`${error?.name} ${error?.message}`);

export const reloadForNewVersion = (error) => {
  if (!isChunkLoadError(error)) return false;
  let last = 0;
  try { last = Number(window.sessionStorage.getItem(RELOAD_KEY)) || 0; } catch { /* stockage indisponible */ }
  if (Date.now() - last < RELOAD_WINDOW_MS) return false;
  try { window.sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* stockage indisponible */ }
  window.location.reload();
  return true;
};

export const lazyPage = (load) => lazy(() => load().catch((error) => {
  if (reloadForNewVersion(error)) return new Promise(() => {}); // la page se recharge
  throw error;
}));
